import { useOutletContext } from "react-router-dom";

const ReportMistake = () => {
  const { from, to } = useOutletContext<{ from: number, to: number }>()

  console.log(from, to)
  return (
    <>
      <div className="card">
        <div className="card-body">
          <div className="d-flex flex-wrap mt-2">
            <div className="mr-4 mt-2">
              <span className="h1 font-primary mr-2">2</span><span className="text-muted mb-0 tx-12">รายการ</span>
            </div>
            <div className="col-lg-2 ml-auto p-0">
              <span className="tx-13 text-muted">ประเภทรถที่ให้บริการ</span>
              <div className="form-group">
                <select className="form-control">
                  <option value="AL">ทั้งหมด</option>
                  <option value="WY">รถ Taxi</option>
                  <option value="AM">รถรับจ้างขนาดเล็ก</option>
                  <option value="AM">รถรับจ้างขนาดกลาง</option>
                  <option value="AM">รถรับจ้างขนาดใหญ่</option>
                </select>
              </div>
            </div>

            <div>
              <button className="btn btn-primary d-none d-md-block ml-2 mt-4">Export data</button>
            </div>

          </div>



          <div className="table-responsive">
            <table className="table ">
              <thead>
                <tr>
                  <th className="">หมายเลขออเดอร์</th>
                  <th className="">วัน/เดือน/ปี</th>
                  <th className="">ประเภทรถ</th>
                  <th className="text-right">รายละเอียด</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td><a href="order_detail.php">1032022</a></td>
                  <td>1/03/2022</td>
                  <td>รถ Taxi</td>
                  <td className="text-right">ทิ้งผู้โดยสาร</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </>
  )
}
export default ReportMistake;
